module.exports = __webpack_public_path__ + "img/couples-077.55dd4aca.jpg";